export default __webpack_public_path__ + "static/media/HP-D3-RW.697bc2a1.png";